<template>
  <div>
    <base-box class="table-box">
      <base-table :title="title" :headers="headers" :items="items" :items-per-page="itemsPerPage" @seeAll="seeAll" />
    </base-box>
    <!-- Drawer para ver todos -->
    <base-drawer title="Ver todos" :open="drawerAll">
        <base-card>
          <base-table :title="title" :headers="headers" :items="items" :items-per-page="itemsPerPage" :drawer-mode="true" />
        </base-card>
    </base-drawer>
  </div>
</template>

<script>
import BaseBox from '@/components/Box'
import BaseCard from '@/components/Card'
import BaseDrawer from '@/components/Drawer'

import BaseTable from '@/containers/Table'
export default {
  props: {
    title: {},
    headers: {},
    items: {},
    itemsPerPage: {
      default: 5
    }
  },
  data () {
    return {
      drawerAll: false
    }
  },
  components: {
    BaseBox,
    BaseTable,
    BaseDrawer,
    BaseCard
  },
  methods: {
    seeAll () {
      this.drawerAll = !this.drawerAll
    }
  }
}
</script>